import { Sparkles, Loader2 } from "lucide-react";

interface ActionsSectionProps {
  isDark: boolean;
  isGenerating: boolean;
  isFormValid: boolean;
  error: string;
  onGenerateClick: () => void;
}

export const ActionsSection: React.FC<ActionsSectionProps> = ({
  isDark,
  isGenerating,
  isFormValid,
  error,
  onGenerateClick,
}) => {
  return (
    <div className="col-span-full">
      <button
        onClick={onGenerateClick}
        disabled={isGenerating || !isFormValid}
        className="w-full py-4 px-6 text-white font-bold rounded-xl hover:opacity-90 transition-all shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
        style={{ backgroundColor: "var(--primary-color)" }}
      >
        {isGenerating ? (
          <>
            <Loader2 className="w-6 h-6 animate-spin" />
            Gerando atividade com IA...
          </>
        ) : (
          <>
            <Sparkles className="w-6 h-6" />
            Gerar Atividade Completa com IA
          </>
        )}
      </button>
      {error && (
        <p
          className="text-sm mt-3 text-center font-medium text-red-600"
          style={{ color: "var(--danger-color, #dc2626)" }}
        >
          {error}
        </p>
      )}
    </div>
  );
};
